// Testimonials.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import thewormherder from '../assets/img/worm-herder-logo.png';

export const Testimonials = () => {
  const testimonialsData = [
    {
      id: 1,
      name:' The Worm Herder',
      image: thewormherder,
      testimonial: `
      Hey folks,
      
      Big shout-out to Tristan Wentzel for our awesome Worm Herder website. Not tech whizzes, but Tristan made it a breeze. Our ideas turned into a user-friendly site. He captured our vibe, and clients love it. Working with him was like hanging out with a web-savvy friend. Need a website guru? Tristan's your man.
      
      Cheers,
      Jolene and Jethro, The Worm Herder Bosses`,
    },
    {
      id: 2,
      name:' The Worm Herder',
      image: thewormherder,
      testimonial: `
      Hey folks,
      
      Big shout-out to Tristan Wentzel for our awesome Worm Herder website. Not tech whizzes, but Tristan made it a breeze. Our ideas turned into a user-friendly site. He captured our vibe, and clients love it. Working with him was like hanging out with a web-savvy friend. Need a website guru? Tristan's your man.
      
      Cheers,
      Jolene and Jethro, The Worm Herder Bosses`,
    },
    {
      id: 3,
      name:' The Worm Herder',
      image: thewormherder,
      testimonial: `
      Hey folks,
      
      Big shout-out to Tristan Wentzel for our awesome Worm Herder website. Not tech whizzes, but Tristan made it a breeze. Our ideas turned into a user-friendly site. He captured our vibe, and clients love it. Working with him was like hanging out with a web-savvy friend. Need a website guru? Tristan's your man.
      
      Cheers,
      Jolene and Jethro, The Worm Herder Bosses`,
    },

  ];

  return (
    <div className="testimonials-container">
      <Container>
        <Row className="justify-content-center align-items-center">
          {testimonialsData.map((testimonial) => (
            <Col key={testimonial.id} xs={12} md={4}>
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">{testimonial.testimonial}</p>
                  <div className="testimonial-footer">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="testimonial-image"
                      style={{ width: '50px', height: '50px' }}
                    />
                    <p className="testimonial-name">{testimonial.name}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Testimonials;










